import { createAtom } from "../structures/jazzi/atom";

type Auth = { loggedOut: boolean }

export const AuthAtom = createAtom<Auth>({ loggedOut: false })